import AllChainIcon from "@/assetsV3/Wallet/Chains/AllChainIcon";
import BaseChainIcon from "@/assetsV3/Wallet/Chains/BaseChainIcon";
import BscChainIcon from "@/assetsV3/Wallet/Chains/BscChainIcon";
import EthChainIcon from "@/assetsV3/Wallet/Chains/EthChainIcon";
import SolanaChainIcon from "@/assetsV3/Wallet/Chains/SolanaChainIcon";
import SonicWallet from "@/assetsV3/Wallet/Deposit/SonicWallet";

export const PredictorsFilterValues = [
  {
    id: 2,
    title: "Day",
    value: "1d",
  },
  {
    id: 3,
    title: "Week",
    value: "7d",
  },
  {
    id: 4,
    title: "Month",
    value: "30d",
  },
];

export const ChainFilterValues = [
  {
    id: 0,
    title: "All Chains",
    value: "chain",
    icon: AllChainIcon,
  },
  {
    id: 1,
    title: "Solana",
    value: "solana",
    icon: SolanaChainIcon,
  },
  {
    id: 2,
    title: "Base",
    value: "base",
    icon: BaseChainIcon,
  },
  // {
  //   id: 3,
  //   title: "BSC (BEP20)",
  //   value: "bsc",
  //   icon: BscChainIcon,
  // },
  // {
  //   id: 4,
  //   title: "Sonic",
  //   value: "sonic",
  //   icon: SonicWallet,
  // },
  // {
  //   id: 5,
  //   title: "Ethereum",
  //   value: "ethereum",
  //   icon: EthChainIcon,
  // },
];
